import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navigation = () => {
  const location = useLocation();
  const { getCartCount, setIsCartOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const count = getCartCount();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { to: '/products', label: 'Shop' },
    { to: '/blog', label: 'Journal' },
    { to: '/about', label: 'About' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-bb-black/95 backdrop-blur-md border-b border-bb-border' : 'bg-transparent'
        }`}
        data-testid="navigation"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="group" data-testid="nav-logo">
              <span className="font-heading text-2xl tracking-[0.35em] c-cream group-hover:c-gold transition-colors">
                BEE BOOSTED
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-12">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`nav-${l.label.toLowerCase()}`}
                  className={`t-nav transition-colors ${
                    location.pathname.startsWith(l.to) ? 'c-gold' : 'c-muted hover:c-cream'
                  }`}
                >
                  {l.label}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-5">
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative group flex items-center gap-2"
                data-testid="nav-cart-button"
              >
                <ShoppingBag className="w-5 h-5 c-cream group-hover:text-bb-gold transition-colors" />
                {count > 0 && (
                  <span className="absolute -top-2 -right-3 w-5 h-5 bg-bb-gold text-bb-black text-[10px] font-bold flex items-center justify-center">
                    {count}
                  </span>
                )}
              </button>

              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="md:hidden p-1"
                data-testid="mobile-menu-toggle"
              >
                {mobileOpen ? (
                  <X className="w-5 h-5 c-cream" />
                ) : (
                  <Menu className="w-5 h-5 c-cream" />
                )}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-bb-black flex flex-col items-center justify-center gap-10 md:hidden">
          <Link to="/" onClick={() => setMobileOpen(false)} className="font-heading text-3xl c-cream">
            BEE BOOSTED
          </Link>
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setMobileOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="t-nav text-lg c-muted hover:c-gold transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <button
            onClick={() => { setIsCartOpen(true); setMobileOpen(false); }}
            className="t-nav text-lg c-muted hover:c-gold transition-colors"
          >
            Bag ({count})
          </button>
        </div>
      )}
    </>
  );
};

export default Navigation;
